import React from 'react';
import Carte from '../ui/Carte';
import ChampTexte from '../champs/ChampTexte';
import ChampSelect from '../champs/ChampSelect';


function SectionInfosGenerales({ donnees, onChange }) {
  return (
    <Carte titre="Informations générales" icone="📋">
      <div className="grille grille--2col">
        <ChampTexte
          label="Référence du document"
          valeur={donnees.reference}
          onChange={onChange}
          nom="reference"
          placeholder="ex : 06_CE_2026_04_FEUILLET"
          infobulle="numDoc_CE_AAAA_MM_ÉTUDE"
        />
        <ChampTexte
          label="Nom de l'étude"
          valeur={donnees.nomEtude}
          onChange={onChange}
          nom="nomEtude"
          placeholder="ex : Étude de marché e-commerce"
        />
        
      </div>
    </Carte>
  );
}

export default SectionInfosGenerales;
